export default __webpack_public_path__ + "static/media/roya-uni.d3b54cdb.svg";